import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./auth.css";
import { API_URL } from "../../URL";
import { useDispatch } from "react-redux";
import { SET_USER } from "../../store/constants";
import {getCookie} from "../../hooks/getCookie";

export default function Login() {
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const csrfToken = getCookie("csrftoken");
            const send = await fetch(API_URL + "/login/", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": csrfToken,
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await send.json();

            if (data.loggedIn) {
                dispatch({ type: SET_USER, payload: data.user });
                navigate("/cabinet");
            }

            if(data.detail){
                setPassword("");
                setError(data.detail);
            }
        } catch (error) {
            console.error("Login error:", error);
        }
    };

    return (
        <div className="container">
            <div className="forms">
                <form onSubmit={handleSubmit}>
                    <div className="form-title">
                        <p>login form</p>
                    </div>

                    <div className="form-row">
                        <div className="form">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                className="email input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="form">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                className="password input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {/*<a href="#">Forgot password?</a>*/}
                        </div>
                        {
                            Boolean(error) && (
                                <div className="form__error">
                                    <p>{error}</p>
                                </div>
                            )
                        }
                        <div className="form">
                            <button className="form__button" type="submit">
                                LOGIN
                            </button>
                        </div>

                    </div>

                    <div className="form-row">
                        <p>
                            Not a member? <Link to="/register">Signup now</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}